var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2016,
    height: 2016,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C292.05 0 584.1 0 885 0 C885 292.05 885 584.1 885 885 C592.95 885 300.9 885 0 885 C0 592.95 0 300.9 0 0 Z ",
    fill: "#FEBA08",
    transform: "translate(1046,1046)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C292.05 0 584.1 0 885 0 C885 292.05 885 584.1 885 885 C592.95 885 300.9 885 0 885 C0 592.95 0 300.9 0 0 Z ",
    fill: "#05A6F0",
    transform: "translate(85,1046)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C292.05 0 584.1 0 885 0 C885 292.05 885 584.1 885 885 C592.95 885 300.9 885 0 885 C0 592.95 0 300.9 0 0 Z ",
    fill: "#81BC06",
    transform: "translate(1046,85)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C292.05 0 584.1 0 885 0 C885 292.05 885 584.1 885 885 C592.95 885 300.9 885 0 885 C0 592.95 0 300.9 0 0 Z ",
    fill: "#F35224",
    transform: "translate(85,85)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftlogo);
export default __webpack_public_path__ + "static/media/microsoftlogo.a96724b6831ad3e300d864ac4731e9fb.svg";
export { ForwardRef as ReactComponent };